<template>
    <div class="">

        <div class="page-title-area"
            :style="'background-image:url('+ background +')'">
            <div class="d-table">
                <div class="d-table-cell">
                    <div class="container">
                        <div class="title-item">

                            <!-- Data -->
                            <h2 
                                v-if="title">
                                {{ title }}
                            </h2>
                            <ul v-if="title">
                                <li>
                                    <router-link 
                                        :to="'/home'">
                                        {{ $t('app.home') }}
                                    </router-link>
                                </li>
                                <li>
                                    <a>{{ title }}</a>
                                </li>
                            </ul>
                            <!-- End Data  -->

                            <!-- webkit animation -->
                            <div  
                                v-if="!title"
                                class="webkit-animation col-4 offset-4 webkit-none-80">
                            </div>  
                            <div v-if="!title" class="row mt-2">
                                <div class="col-4"></div>
                                <div class="col-2 pd-5">
                                    <div 
                                        class="webkit-animation webkit-80per-50 float-right" 
                                        :class="($i18n.locale == 'en') ? 'float-right' : 'float-left'"></div>
                                </div>
                                <div class="col-2 pd-5">
                                    <div class="webkit-animation webkit-80per-50"></div>
                                </div>
                            </div>
                            <!-- End webkit animation -->
                            
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="hasFlag" class="embassy-flag-container">
                <div 
                    class="embassy-flag"
                    :style="'background-image: url('+flag+') !important;background-color: #fff'">
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'Banner',
    props: [
        'background',
        'title',
        'hasFlag',
        'flag'
    ],
    components: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
